import { IProductDefinition } from "../../../../types/journeyInput.types";
import { advisedAnnuityJourney, pensionReviewJourney, annualReviewJourney } from "../../../journeys";

export const myPensionProductDefinition: IProductDefinition = {
  productId: "my-pension",
  productName: "Accessing My Pension",
  journeys: [
    advisedAnnuityJourney,
    pensionReviewJourney,
    annualReviewJourney
  ],
  qualificationRules: true,
  available: true,
};
